import { focusOutline } from "../../Resources/CSS/styling"

export const TextArea = ({ id, name, label, placeholder, type, value, onChange, className, rows = 4 }) => {
    return (
        <div>
            <label htmlFor={id} className="block text-sm/6 font-medium text-gray-900">
                {label}
            </label>
            <div className="mt-2">
                <textarea
                    id={id}
                    onChange={onChange}
                    name={name}
                    rows={rows}
                    className={`block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 ${focusOutline} sm:text-sm/6 ${className}`}
                    defaultValue={value}
                />
            </div>
        </div>
    )
}